var $fe136bcbacfcfa14$exports = {};
$fe136bcbacfcfa14$exports = {
    "close": `Chiudi`,
    "notifications": `Notifiche`
};


export {$fe136bcbacfcfa14$exports as default};
//# sourceMappingURL=it-IT.module.js.map
